<template>
    <!-- 智能ERP -->
  <div class="repView">
    <div class="erpTitle erpTitleMd" >
        <img class="erpTitleMdImg" src="./img/title.png" alt="">
    </div>
    <div class="erpTitle erpicon" >
        <img src="./img/titleB.png" alt="">
    </div>
    <div class="erpTxet" >
        <p>随着国家政策变更、供给侧改革及互联网的深入发展，流通行业的市场环境发生了很大的变化，企业对内部管理的要求越来越高。在这样的背景下，很多企业对ERP管理系统也提出了更高的要求。</p>
        <p>如何通过ERP系统提升企业自身管理精细度，提升市场营销能力、提升客户服务体验，成为了企业新的课题。</p>
        <div>新市场环境下对 <span>ERP系统</span> 的要求</div>
    </div>
    <div class="erpTitle erpone " >
        <img class="image" src="./img/titleC.png" alt="">
    </div>
    <div class="erpTitle erptwo " >
        <img class="image" src="./img/titleA.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'repView'

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.erpTitle{
    display: flex;
    justify-content: center;
    background-color: #FFFFFF;
}
.erpTitleMd{
    width: 750px/$md;
    height: 300px/$md;
    overflow: hidden;
    display: flex;
    justify-content: center;
    .erpTitleMdImg{
        height: 100%;
    }
}
.image{
    width: 100%;
    height: 100%;
}
.erpicon{
    padding: 50px/$md 0 40px/$md 0;
    img{
    width: 242px/$md;
    height: 107px/$md;
    }
}
.erpTxet{
    // flex-direction: column;
    padding:  0 27px/$md 40px/$md 27px/$md;
    font-size: 24px/$md;
    color: #666666;
    line-height: 200%;
}
.erpTxet div{
    margin-top: 40px/$md;
    color: #000000;
    // padding-bottom: 40px/$md;
}
.erpTxet div span{
    color: #FF0000;
}
.erpone{
    margin: 20px/$md 22px/$md 0 22px/$md;
    padding-bottom: .625rem;

}
.erptwo{
    padding-bottom: .8rem;
    margin: 20px/$md 22px/$md 0 22px/$md;
}
</style>
